import { render, staticRenderFns } from "./Exponentialekvation1.vue?vue&type=template&id=ed60e3a2&scoped=true&"
import script from "./Exponentialekvation1.vue?vue&type=script&lang=js&"
export * from "./Exponentialekvation1.vue?vue&type=script&lang=js&"
import style0 from "./Exponentialekvation1.vue?vue&type=style&index=0&id=ed60e3a2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed60e3a2",
  null
  
)

export default component.exports